import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiResponse, PaginationResponse} from "../../base/repository/entity/base.entity";
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {FilterDashboardDTO} from "../dto/dashboard.dto";
import {
  DashboardBranchList,
  DashboardBranchQuery,
  DashboardMenuList,
  DashboardMenuQuery,
  DataChart,
  DataMenuOverall,
  DataRatedMenus,
  DataReviewedMenus,
  DataVenueOverall
} from "./entity/dashboard.entity";

@Injectable({
  providedIn: 'root',
})
export class DashboardRepository {

  constructor(private http: HttpClient) {
  }

  fetchDataChart(date: FilterDashboardDTO): Observable<ApiResponse<DataChart>> {
    return this.http.get<ApiResponse<DataChart>>(
      `${environment.baseUrl}/dashboard/venue/chart?branch=${date.branch}&startAt=${date.prevDate}&endAt=${date.currentDate}`
    );
  }

  fetchMenuOverall(date: FilterDashboardDTO): Observable<ApiResponse<DataMenuOverall>> {
    return this.http.get<ApiResponse<DataVenueOverall>>(
      `${environment.baseUrl}/dashboard/menu/overall?branch=${date.branch}&startAt=${date.prevDate}&endAt=${date.currentDate}`
    );
  }

  fetchMenuDataChart(date: FilterDashboardDTO): Observable<ApiResponse<DataChart>> {
    return this.http.get<ApiResponse<DataChart>>(
      `${environment.baseUrl}/dashboard/menu/chart?branch=${date.branch}&menu=${date.menuIds}&startAt=${date.prevDate}&endAt=${date.currentDate}`
    );
  }

  fetchVenueOverall(date: FilterDashboardDTO): Observable<ApiResponse<DataVenueOverall>> {
    return this.http.get<ApiResponse<DataVenueOverall>>(
      `${environment.baseUrl}/dashboard/venue/overall?branch=${date.branch}&startAt=${date.prevDate}&endAt=${date.currentDate}`
    );
  }

  fetchVenueSection(date: FilterDashboardDTO): Observable<ApiResponse<DataVenueOverall[]>> {
    return this.http.get<ApiResponse<DataVenueOverall[]>>(
      `${environment.baseUrl}/dashboard/venue/section?branch=${date.branch}&startAt=${date.prevDate}&endAt=${date.currentDate}&limit=3`
    );
  }

  fetchRatedMenus(date: FilterDashboardDTO): Observable<ApiResponse<DataRatedMenus[]>> {
    return this.http.get<ApiResponse<DataRatedMenus[]>>(
      `${environment.baseUrl}/dashboard/menu/top-rated?branch=${date.branch}&startAt=${date.prevDate}&endAt=${date.currentDate}&limit=10`
    );
  }

  fetchReviewedMenus(date: FilterDashboardDTO): Observable<ApiResponse<DataReviewedMenus[]>> {
    return this.http.get<ApiResponse<DataReviewedMenus[]>>(
      `${environment.baseUrl}/dashboard/menu/top-reviewed?branch=${date.branch}&startAt=${date.prevDate}&endAt=${date.currentDate}&limit=10`
    );
  }

  getBranch(
    query: DashboardBranchQuery = {
      limit: 9999,
      page: 1,
      q: ""
    }
  ): Observable<ApiResponse<PaginationResponse<DashboardBranchList[]>>> {
    return this.http.get<ApiResponse<PaginationResponse<DashboardBranchList[]>>>(
      `${environment.baseUrl}/branch?${this.dashboardQuery(query)}`
    );
  }

  getMenu(
    query: DashboardMenuQuery = {
      limit: 9999,
      page: 1,
      q: ""
    }
  ): Observable<ApiResponse<PaginationResponse<DashboardMenuList[]>>> {
    return this.http.get<ApiResponse<PaginationResponse<DashboardMenuList[]>>>(
      `${environment.baseUrl}/menu?${this.dashboardQuery(query)}`
    );
  }

  private dashboardQuery(query: DashboardBranchQuery) {
    const params = new HttpParams()
      .set('limit', query.limit.toString())
      .set('page', query.page.toString());

    return params.toString();
  }

}
